import PropTypes from "prop-types";
import { ConnectionSuccessIcon } from "assets/icons/index";
import { getBrokerIcon } from "utils/index";
import {
  ButtonStyleContainer,
  SuccessContainer,
} from "./SnaptradeModal.styles";

const StepSuccess = ({ show, onHide, onSuccess, broker }) => {
  return (
    <SuccessContainer show={show} onHide={onHide}>
      <div className="content-wrapper">
        <img
          src={ConnectionSuccessIcon}
          alt={"success connection"}
          className="connection-success"
        />

        <h2>Portfolio connected!</h2>
        <p>
          You have successfully connected your{" "}
          <img
            src={getBrokerIcon(broker.square_logo_url)}
            alt={broker.display_name}
            className="broker-logo"
          />{" "}
          <strong>Robinhood</strong> account with Surmount. You can now
          implement any strategy or investment plan and access customized data
          insights tailored for you.
        </p>
        <div className="action-buttons">
          <ButtonStyleContainer>
            <button className="btn btn-view-portfolio" onClick={onSuccess}>
              View Portfolio
            </button>
          </ButtonStyleContainer>
          <button className="btn-back-dashboard" onClick={onHide}>
            Back to Dashboard
          </button>
        </div>
      </div>
    </SuccessContainer>
  );
};

StepSuccess.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  broker: PropTypes.object,
};

export default StepSuccess;
